import { render, staticRenderFns } from "./orders-view.vue?vue&type=template&id=22850661&scoped=true"
import script from "./orders-view.vue?vue&type=script&lang=js"
export * from "./orders-view.vue?vue&type=script&lang=js"
import style0 from "./orders-view.vue?vue&type=style&index=0&id=22850661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22850661",
  null
  
)

export default component.exports